import React from 'react'
import cn from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SocialProvider } from '../../../services/keycloakAuth'

import styles from './SocialButton.module.scss'

const GoogleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" className={styles.icon}>
        <path d="M14.0001 6.38789C15.8586 6.38789 17.5229 7.02839 18.8354 8.27789L22.4316 4.68164C20.2476 2.64989 17.3969 1.40039 14.0001 1.40039C9.07564 1.40039 4.81789 4.22489 2.74414 8.34089L6.93364 11.5906C7.92589 8.60339 10.7136 6.38789 14.0001 6.38789Z" fill="#EA4335"/>
        <path d="M26.0645 14.2891C26.0645 13.4649 25.9857 12.6669 25.865 11.9004H14V16.6359H20.7935C20.489 18.1899 19.607 19.5129 18.284 20.4054L22.3422 23.5554C24.71 21.3609 26.0645 18.1164 26.0645 14.2891Z" fill="#4285F4"/>
        <path d="M6.92815 16.4101C6.67615 15.6488 6.52915 14.8403 6.52915 14.0003C6.52915 13.1603 6.6709 12.3518 6.92815 11.5906L2.73865 8.34082C1.8829 10.0418 1.3999 11.9633 1.3999 14.0003C1.3999 16.0373 1.8829 17.9588 2.7439 19.6598L6.92815 16.4101Z" fill="#FBBC05"/>
        <path d="M14 26.5998C17.402 26.5998 20.2633 25.4815 22.3423 23.5495L18.284 20.3995C17.1553 21.1608 15.701 21.607 14 21.607C10.7135 21.607 7.92577 19.3915 6.92827 16.4043L2.73877 19.654C4.81777 23.7753 9.07552 26.5998 14 26.5998Z" fill="#34A853"/>
    </svg>
)

interface SocialButtonProps {
    provider: SocialProvider
    label: string
    onClick: () => void
    disabled?: boolean
    className?: string
}

const SocialButton: React.FC<SocialButtonProps> = ({ provider, label, onClick, disabled = false, className }) => {
    return (
        <button className={cn(styles.socialButton, className)} onClick={onClick} disabled={disabled} type="button">
            {provider === 'google'
                ? <GoogleIcon />
                : <FontAwesomeIcon icon={['fab', provider === 'apple' ? 'apple' : 'facebook-f']} className={styles.icon} />
            }
            <span className={styles.label}>{label}</span>
        </button>
    )
}

export default SocialButton
